import { useQuery } from '@tanstack/react-query';

import { getAttractionCities } from '~/services/AttractionsService';

import { attractionQueryKeys } from './attractionQueryKeys';

interface UseGetAttractionCitiesOptions {
  enabled?: boolean;
}

/**
 * Fetches cities with attraction coverage data.
 */
export function useGetAttractionCities(options: UseGetAttractionCitiesOptions = {}) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: attractionQueryKeys.cities(),
    queryFn: async ({ signal }) => {
      return await getAttractionCities({ signal });
    },
    enabled,
    retry: false,
  });
}
